import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseHttpService } from '../base/_base-http.service';
import { Config } from '../config/env.config';
import { contentHeaders } from 'common/headers';

import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';
import {of} from 'rxjs/internal/observable/of';


@Injectable()
export class ProfileInfoService extends BaseHttpService {

  private rootUrl: string = 'profile';

  fetch(): Observable<any> {
    return this.http.get(`${Config.API}/user`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  put(data: any): Observable<any> {
    const body = JSON.stringify(data);
    return this.http.put(`${Config.API}/user`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  matchCurrentPassword(password: string) {
    const res = password === 'Qw*00000' ? 'valid' : 'invalid';
    return of(res);
  }

  userResetPassword(password: string, newPassword: string, confirmNewPassword: string) {
    const body = JSON.stringify({
      password: password,
      new_password: newPassword,
      new_password_confirmation : confirmNewPassword
    });

    return this.http.put(`${Config.API}/user/reset-password`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }

  fetchPermissions(brandId: string, userId: number): Observable<any> {
    return this.http.get(`${Config.API}/user/${brandId}/permissions/${userId}`)

        .pipe(catchError(this.handleError.bind(this)));
  }

  putPermissions(brandId: string, userId: number, data: any): Observable<any> {
    const body = JSON.stringify( data );
    return this.http.put(`${Config.API}/user/${brandId}/permissions/${userId}`, body, {headers: contentHeaders})

        .pipe(catchError(this.handleError.bind(this)));
  }
}
